import { Link } from 'react-router-dom';

interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

interface CategoryNavProps {
  categories: Category[];
}

export default function CategoryNav({ categories }: CategoryNavProps) {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            按类型探索看片网站
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            根据您的观影偏好，快速找到对应类型的优质看片网站
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-4 p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-background-100 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-foreground-600 group-hover:text-primary-600 transition-colors duration-300`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-400">{cat.count}个网站</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}